import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './JobDetails.css';
import axios from 'axios';

const jobsData = [
  { id: 1, title: 'Software Engineer', location: 'Chennai', description: 'Develop and maintain web applications.', experience: '2-4 years', department: 'Engineering' },
  { id: 2, title: 'Product Manager', location: 'Bangalore', description: 'Lead product development teams.', experience: '5+ years', department: 'Product Management' },
  { id: 3, title: 'Data Analyst', location: 'Coimbatore', description: 'Analyze and interpret complex data sets.', experience: '1-3 years', department: 'Data Analytics' },
  { id: 4, title: 'UI/UX Designer', location: 'Hyderabad', description: 'Design and enhance user interfaces.', experience: '3-5 years', department: 'Design' },
  { id: 5, title: 'Marketing Specialist', location: 'Coimbatore', description: 'Develop and execute marketing strategies.', experience: '2-4 years', department: 'Marketing' },
];

const JobDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const job = jobsData.find((job) => job.id === parseInt(id));
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    currentLocation: '',
    preferredLocation: '',
    totalExperience: '',
    currentSalary: '',
    expectedSalary: '',
    noticePeriod: '',
    linkedin: '',
    resume: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!job) {
    return <p>Job not found</p>;
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    const applicationData = new FormData();
    Object.keys(formData).forEach((key) => {
      applicationData.append(key, formData[key]);
      console.log(`FormData key: ${key}, value:`, formData[key]); // Debugging
    });
  
    applicationData.append('jobId', job.id);
    applicationData.append('jobDescription', job.description);
  
    console.log('Final FormData contents:', Object.fromEntries(applicationData.entries())); // Log all FormData entries
  
    setIsSubmitting(true);
    try {
      const response = await axios.post('http://localhost:5000/api/job-applications', applicationData, {
        headers: {
          // Don't set 'Content-Type' manually; Axios does it automatically for FormData
        },
      });
      console.log('Server Response:', response.data);
      alert(response.data.message || 'Application submitted successfully.');
      setShowForm(false);
    } catch (error) {
      console.error('Error submitting application:', error);
      alert(error.response?.data?.message || 'Failed to submit the application.');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  
  

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (files && files.length > 0) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  

  return (
    <>
      <div className='job-title'>
        <h1>{job.title}</h1>
      </div>
      <div className="job-details">
        <div className="job-field">
          <h3>About the Role</h3>
          <p>We are looking for a skilled and passionate Software Developer to join our dynamic development team. You will be responsible for designing, coding, and debugging applications while ensuring top-notch quality and performance. This role requires creativity, problem-solving skills, and a deep understanding of modern software development practices.</p>
        </div>
        <div className="job-field">
          <h3>Location</h3>
          <p>{job.location}</p>
        </div>
        <div className="job-field">
          <h3>Key Responsibilities</h3>
          <ul>
            <li>Design, develop, and implement software applications based on business requirements.</li>
            <li>Collaborate with cross-functional teams to define, design, and ship new features.</li>
            <li>Write clean, scalable, and maintainable code following industry best practices.</li>
            <li>Debug and optimize existing software to enhance performance and reliability.</li>
            <li>Perform unit testing and integration testing to ensure high-quality deliverables.</li>
            <li>Document code, processes, and development workflows for future reference.</li>
            <li>Stay updated with the latest trends and technologies in software development.</li>
            <li>Provide technical support and troubleshooting for software issues.</li>
          </ul>
        </div>
        <div className="job-field">
          <h3>Experience Required</h3>
          <p>{job.experience}</p>
        </div>
        <div className="job-field">
          <h3>Preferred Qualifications</h3>
          <ul>
            <li>Experience with cloud platforms like AWS, Azure, or Google Cloud.</li>
            <li>Knowledge of DevOps practices and tools (CI/CD pipelines, Docker, Kubernetes).</li>
            <li>Familiarity with testing frameworks (e.g., Jest, Mocha, Selenium).</li>
          </ul>
        </div>
        <div className='job-field'>
          <h3>Application Process</h3>
          <p>If you're excited to work on challenging projects and grow your career, we'd love to hear from you! Send your resume to <a href="mailto:careers@ourcompany.com" className="mail-link">careers@ourcompany.com</a>.</p>
        </div>
        <button className="apply-btn" onClick={() => setShowForm(true)}>Apply Now</button>
        <button className="back-btn" onClick={() => navigate(-1)}>Back</button>
      </div>
      {showForm && (
        <div className="application-form">
          <h3>Application Form</h3>
          <form onSubmit={handleFormSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">First Name:</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name:</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number:</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="currentLocation">Current Location:</label>
              <input
                type="text"
                id="currentLocation"
                name="currentLocation"
                value={formData.currentLocation}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="preferredLocation">Preferred Location:</label>
              <input
                type="text"
                id="preferredLocation"
                name="preferredLocation"
                value={formData.preferredLocation}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="totalExperience">Total Experience:</label>
              <input
                type="text"
                id="totalExperience"
                name="totalExperience"
                value={formData.totalExperience}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="currentSalary">Current Salary:</label>
              <input
                type="text"
                id="currentSalary"
                name="currentSalary"
                value={formData.currentSalary}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="expectedSalary">Expected Salary:</label>
              <input
                type="text"
                id="expectedSalary"
                name="expectedSalary"
                value={formData.expectedSalary}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="noticePeriod">Notice Period:</label>
              <input
                type="text"
                id="noticePeriod"
                name="noticePeriod"
                value={formData.noticePeriod}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="linkedin">LinkedIn Profile:</label>
              <input
                type="url"
                id="linkedin"
                name="linkedin"
                value={formData.linkedin}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="resume">Resume:</label>
              <input
                type="file"
                id="resume"
                name="resume"
                onChange={handleInputChange}
                required
              />
            </div>
            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </div>
      )}
    </>
  );
};

export default JobDetails;
